module.exports = __webpack_public_path__ + "img/mike.69a379ce.jpg";